// 2025-05-04: プログレスバーの状態別スタイルを head に追加する処理
import { queryHeaderElements, queryHeaderElementsInElement } from '@/helpers/headerShadow';

export const injectHeaderLineStyles = () => {
  if (document.getElementById('storeeel-header-style')) return;

  const styleTag = document.createElement('style');
  styleTag.id = 'storeeel-header-style';
  styleTag.innerHTML = `
    .storeeel-movie-select_banner {
      height: 3px;
      background-color: rgba(255, 255, 255, 0.2);
      margin: 0 3px;
      position: relative;
      overflow: hidden;
      width: var(--banner-width, calc(100% / 1));
      display: block;
    }

    .storeeel-movie-select_banner::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background-color: white;
      width: 0%;
      /* これで常に running（再開） */
      animation-play-state: running;
    }

    .storeeel-movie-select_banner.active::before {
      animation: progressBarAnimation var(--duration, 3s) linear forwards;
      animation-delay: var(--progress-delay, 0s);
    }

    .storeeel-movie-select_banner.completed::before {
      width: 100%;
      background-color: white;
      animation: none;
    }

    .storeeel-movie-select_banner.paused::before {
      animation-play-state: paused !important;
    }

    @keyframes progressBarAnimation {
      0% { width: 0%; }
      100% { width: 100%; }
    }
  `;
  document.head.appendChild(styleTag);
};

// 2025-05-04: 動画の再生時間に応じた進捗バー制御処理

// 対象インデックスのバーをアニメーション開始
export const animateCurrentProgressBar = (duration, index) => {
  const bars = queryHeaderElements('.storeeel-movie-select_banner');
  if (!bars[index]) return;
  // 画像/動画切り替え時に一時停止が残らないよう進捗を再開する
  resumeAllProgressBars();
  resetAllProgressBars(); // 全てのバーを初期状態に戻す

  for(let i = 0; i < index; i++){
    markProgressBarComplete(i); // 完了状態に変更
  }

  // リセットしてアニメーション再実行を確実にする
  bars[index].classList.remove('active');
  void bars[index].offsetWidth; // reflow 強制
  bars[index].style.setProperty('--duration', `${duration}s`);
  bars[index].classList.add('active');
};

// 読み込み/再生待ちの間は「開始前」の状態に整える（アニメーションは開始しない）
export const prepareCurrentProgressBar = (index) => {
  const bars = queryHeaderElements('.storeeel-movie-select_banner');
  if (!bars[index]) return;
  resetAllProgressBars();
  for (let i = 0; i < index; i++) {
    markProgressBarComplete(i);
  }
};

// 対象インデックスのバーを完了状態に変更
export const markProgressBarComplete = (index) => {
  const bars = queryHeaderElements('.storeeel-movie-select_banner');
  if (!bars[index]) return;
  bars[index].classList.remove('active');
  bars[index].classList.add('completed');
};

// 全てのバーを初期状態に戻す（グループ切り替え時など）
export const resetAllProgressBars = () => {
  queryHeaderElements('.storeeel-movie-select_banner').forEach((bar) => {
    bar.classList.remove('active', 'completed', 'paused');
    bar.style.removeProperty('--duration');
    bar.style.removeProperty('--progress-delay');
  });
};

// 進捗バーを一時停止する関数
export const pauseAllProgressBars = () => {
  queryHeaderElements('.storeeel-movie-select_banner.active')
    .forEach(bar => bar.classList.add('paused'));
};

// 進捗バーを再開する関数
export const resumeAllProgressBars = () => {
  queryHeaderElements('.storeeel-movie-select_banner.paused')
    .forEach(bar => bar.classList.remove('paused'));
};

const resetProgressBars = (bars) => {
  bars.forEach((bar) => {
    bar.classList.remove('active', 'completed', 'paused');
    bar.style.removeProperty('--duration');
    bar.style.removeProperty('--progress-delay');
  });
};

const markProgressBarCompleteInList = (bars, index) => {
  const bar = bars[index];
  if (!bar) return;
  bar.classList.remove('active');
  bar.classList.add('completed');
};

// loop（swiperの複製スライド）環境でも確実に「表示中のヘッダー」だけを動かすためのヘルパー
export const animateCurrentProgressBarInElement = (duration, index, element, startOffsetSeconds = 0) => {
  if (!element) return;
  const bars = queryHeaderElementsInElement('.storeeel-movie-select_banner', element);
  if (!bars[index]) return;
  // 画像/動画切り替え時に一時停止が残らないよう進捗を再開する
  resumeAllProgressBars();

  resetProgressBars(bars);
  for (let i = 0; i < index; i++) {
    markProgressBarCompleteInList(bars, i);
  }

  // リセットしてアニメーション再実行を確実にする
  bars[index].classList.remove('active');
  void bars[index].offsetWidth; // reflow 強制
  bars[index].style.setProperty('--duration', `${duration}s`);
  // プレビュー再生で動画が進んだ位置から始める場合、負の animation-delay で同じ位置からバーを進める
  if (startOffsetSeconds > 0) {
    bars[index].style.setProperty('--progress-delay', `-${startOffsetSeconds}s`);
  } else {
    bars[index].style.removeProperty('--progress-delay');
  }
  bars[index].classList.add('active');
};

// loop環境のアクティブスライド向け：開始前の状態に整える
export const prepareCurrentProgressBarInElement = (index, element) => {
  if (!element) return;
  const bars = queryHeaderElementsInElement('.storeeel-movie-select_banner', element);
  if (!bars[index]) return;

  resetProgressBars(bars);
  for (let i = 0; i < index; i++) {
    markProgressBarCompleteInList(bars, i);
  }
};

// 非アクティブスライドの進捗バーを初期状態へ戻す。
// progressBarAnimation は display:none でも進み続けるため、離脱したスライドのバーを止めないと、
// スワイプで戻った瞬間に「少し進んだ状態」のバーが一瞬見えてしまう（着地後にリセットされる）。
// 表示中のアクティブスライドのバーは進行中のため対象外にする。
export const resetInactiveSlidesProgressBars = (activeSlide) => {
  const slides = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide');
  slides.forEach((slide) => {
    if (slide === activeSlide) return;
    const bars = queryHeaderElementsInElement('.storeeel-movie-select_banner', slide);
    resetProgressBars(bars);
  });
};
